import { stripIndent } from 'common-tags';
import { SubscriptionRebillSucceeded } from './components/SubscriptionRebillSucceeded';

export const subscriptionRebillSucceededEmailTemplate = {
  label: 'Subscription Payment Confirmed',
  description: 'Sent when a recurring subscription payment succeeds',
  icon: 'CheckDoubleLine',
  component: SubscriptionRebillSucceeded,
  defaultTemplate: {
    name: 'Subscription Payment Confirmed',
    subject: {
      en: 'Payment of {{ subscriptionAmount }} confirmed — {{ storeName }}',
      fr: 'Paiement de {{ subscriptionAmount }} confirmé — {{ storeName }}',
      it: 'Pagamento di {{ subscriptionAmount }} confermato — {{ storeName }}',
      es: 'Pago de {{ subscriptionAmount }} confirmado — {{ storeName }}',
      de: 'Zahlung von {{ subscriptionAmount }} bestätigt — {{ storeName }}',
    },
    templateVariables: {
      subscription_rebill_succeeded: {
        body: {
          en: stripIndent`
            <p>Hi {{ customerFirstName }},</p>
            <p>We've successfully processed your recurring payment of <strong>{{ subscriptionAmount }}</strong> for your subscription to <strong>{{ subscriptionName }}</strong>.</p>
            <p><strong>Next billing date:</strong> {{ nextBillingDate }}</p>
            <p>Thank you for being a subscriber!</p>
          `,
          fr: stripIndent`
            <p>Bonjour {{ customerFirstName }},</p>
            <p>Nous avons bien traité votre paiement récurrent de <strong>{{ subscriptionAmount }}</strong> pour votre abonnement à <strong>{{ subscriptionName }}</strong>.</p>
            <p><strong>Prochaine date de facturation :</strong> {{ nextBillingDate }}</p>
            <p>Merci de votre fidélité !</p>
          `,
          it: stripIndent`
            <p>Ciao {{ customerFirstName }},</p>
            <p>Abbiamo elaborato con successo il tuo pagamento ricorrente di <strong>{{ subscriptionAmount }}</strong> per il tuo abbonamento a <strong>{{ subscriptionName }}</strong>.</p>
            <p><strong>Prossima data di fatturazione:</strong> {{ nextBillingDate }}</p>
            <p>Grazie per essere un abbonato!</p>
          `,
          es: stripIndent`
            <p>Hola {{ customerFirstName }},</p>
            <p>Hemos procesado con éxito tu pago recurrente de <strong>{{ subscriptionAmount }}</strong> para tu suscripción a <strong>{{ subscriptionName }}</strong>.</p>
            <p><strong>Próxima fecha de facturación:</strong> {{ nextBillingDate }}</p>
            <p>¡Gracias por ser suscriptor!</p>
          `,
          de: stripIndent`
            <p>Hallo {{ customerFirstName }},</p>
            <p>Wir haben deine wiederkehrende Zahlung von <strong>{{ subscriptionAmount }}</strong> für dein Abonnement <strong>{{ subscriptionName }}</strong> erfolgreich verarbeitet.</p>
            <p><strong>Nächstes Abrechnungsdatum:</strong> {{ nextBillingDate }}</p>
            <p>Vielen Dank für dein Abonnement!</p>
          `,
        },
      },
    },
  },
  variables: [
    { key: 'customerFirstName', label: 'Customer First Name', example: 'John' },
    { key: 'customerLastName', label: 'Customer Last Name', example: 'Doe' },
    { key: 'customerEmail', label: 'Customer Email', example: 'john@example.com' },
    { key: 'storeName', label: 'Store Name', example: 'My Store' },
    { key: 'subscriptionName', label: 'Subscription Name', example: 'VIP Club' },
    { key: 'subscriptionAmount', label: 'Subscription Amount', example: '$19.99' },
    { key: 'nextBillingDate', label: 'Next Billing Date', example: 'May 2, 2026' },
  ],
  utmParameters: {
    utmSource: 'subscription_rebill_succeeded',
    utmMedium: 'email',
  },
  specificParams: undefined,
  mockData: (storeName = 'Demo Store') => ({
    store: {
      id: 'store_preview',
      name: storeName,
      baseCurrency: 'USD',
      presentmentCurrencies: ['USD'],
      chargeCurrencies: ['USD'],
    },
    customer: {
      firstName: 'John',
      lastName: 'Doe',
      email: 'john@example.com',
      locale: 'en-US',
      currency: 'USD',
    },
    subscription: {
      currency: 'USD',
      product: { name: 'VIP Club' },
      priceSnapshot: { currencyOptions: { USD: { amount: 1999 } } },
      nextBillingDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
    },
  }),
  defaultMessages: {
    promotion_title: 'Payment Receipt',
    promotion_subtitle: 'Your subscription payment was successful',
    cta_button: 'View Account',
    footer_text: '© 2025 All rights reserved',
  },
};
